export const BookingDetails = {
  non_app: true,
  // booking_id: "",
  // is_subscription: false,
  booking_status: "BOOKED",
  session_type: "",
  cancellation_date: "",
  cancellation_time: "",
  session_date: "",
  session_time: "",
  session_date_time: "",
  booking_date: "",
  booking_time: "",
  payment_information: {
    amount: "",
    payment_id: "",
  },
  booking_type: "",
  lead_information: {
    uuid: "",
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
  },
  expert_information: {
    uuid: "",
    full_name: "",
    role: "",
  },
  cart_information: {
    promocode: "",
    original_price: "",
    final_price: "",
    subscription: false, //
    pro: false, //
  },
  subscription: {
    session_count: "",
    price: "",
  },
  manoshala_pro: {
    term_length: "",
    price: "",
    module: "",
  },
  therapy_plus: {
    term_length: "",
    price: "",
  },
  therapy_note: {
    gender: "",
    age: 0,
    symptoms: [],
    notes: "",
  },
  physical_session_address: {
    address: "",
    city: "",
    state: "",
    latitude: "",
    longitude: "",
    pin_code: "",
  },
  comment: "",
};
function getMonthName(monthNumber: number) {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  return months[monthNumber - 1];
}

export default function getBookingFormattedDate(date: string) {
  if (!date) return "";
  const dateComponents = date.split("/");
  if (dateComponents.length !== 3) return date;
  let month = parseInt(dateComponents[0], 10);
  let day = parseInt(dateComponents[1], 10);
  const year = dateComponents[2].substring(2);
  // Dates are canonically MM/DD/YYYY, but some booking flows (reschedule, older
  // rows, dates echoed back from the v3 slots API) persist DD/MM/YYYY. When the
  // first field can't be a valid month, treat it as day-first and swap — without
  // this, 06/09 (6 Sep) renders as "9/Jun".
  if ((month > 12 || month < 1) && day >= 1 && day <= 12) {
    [month, day] = [day, month];
  }
  const monthName = getMonthName(month);
  if (!monthName || Number.isNaN(day)) return date;
  return `${day}/${monthName}/${year}`;
}

export function convertTo12HourFormat(time24hr: string) {
  if (!time24hr) return "";
  const [hours, minutes] = time24hr.split(":");
  let period = "AM";

  let hours12 = parseInt(hours, 10);
  let intMinutes = parseInt(minutes, 10);
  if (hours12 >= 12) {
    period = "PM";
    if (hours12 > 12) {
      hours12 -= 12;
    }
  } else if (hours12 === 0) {
    hours12 = 12;
  }

  const formattedHour = hours12 < 10 ? `0${hours12}` : `${hours12}`;
  const formattedMinutes = intMinutes < 10 ? `0${intMinutes}` : `${intMinutes}`;

  return `${formattedHour}:${formattedMinutes} ${period}`;
}
